import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Download } from "lucide-react";
import { AppShell } from "@/components/app/AppShell";
import { UpdateReader } from "@/components/UpdateReader";
import { CommentsThread } from "@/components/CommentsThread";
import { ReactionBar } from "@/components/ReactionBar";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { exportElementToPdf } from "@/lib/download";
import api from "@/lib/api";
import { TenXBrandFooter } from "@/components/TenXBrandFooter";

export default function UpdateReaderPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [update, setUpdate] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/updates/${id}`);
        setUpdate(data);
        api.post(`/updates/${id}/view`).catch((e) => console.error("view record failed", e));
      } catch (e) { console.error("Failed to load update", e); navigate("/portal"); }
      finally { setLoading(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const readerRef = useRef();
  const actions = (
    <div className="flex items-center gap-2">
      <Button variant="outline" size="sm" className="gap-1.5" onClick={() => navigate(-1)} data-testid="back-button"><ArrowLeft className="h-4 w-4" /> Back</Button>
      <Button size="sm" className="gap-1.5" disabled={!update} onClick={() => exportElementToPdf(readerRef.current, `${(update?.title || "update").replace(/[^a-z0-9]+/gi, "-")}.pdf`)} data-testid="export-pdf-button"><Download className="h-4 w-4" /> Export PDF</Button>
    </div>
  );

  return (
    <AppShell title="Update" subtitle={update?.company?.name} actions={actions}>
      {loading ? (
        <p className="text-sm text-muted-foreground">Loading…</p>
      ) : update ? (
        <div className="mx-auto max-w-4xl space-y-6">
          <div ref={readerRef} className="rounded-xl border bg-card p-6">
            <UpdateReader update={update} company={update.company} badge={update.badge} />
            <TenXBrandFooter context="portal-update" className="mt-6" />
          </div>
          <ReactionBar updateId={update.id} canReact />
          <div className="rounded-xl border bg-card p-6"><CommentsThread updateId={update.id} /></div>
        </div>
      ) : null}
    </AppShell>
  );
}
